import * as React from "react";
import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import useSwr from "swr";
import { useSelectedCustomer } from "./Customer";
export function useWorkInProgress() {
	const svc = useService(APIService.serviceKey);
	const { data: customer } = useSelectedCustomer();
	const response = useSwr(["wip", customer?.id], () =>
		customer?.id
			? svc.workInProgress.getWorkInProgress({
					customerId: customer?.id!,
			  })
			: []
	);

	return React.useMemo(() => ({ ...response, data: response.data || [] }), [response]);
}
